<div style="position: relative; min-height: 100%; flex: 1 1 auto;">
  <ng-container *ngIf="surveyLink$ | async as surveyLink">
    <iframe
      #surveyFrame
      title="Survey"
      [src]="!!surveyLink ? surveyLink : ''"
      [ngStyle]="{
        height: iframeStatus.status==='loading' ? '500px' : iframeStatus.height+'px'
      }"
    ></iframe>

    <app-card-overlay
      *ngIf="!surveyLink || !iframeStatus || iframeStatus.status==='loading'"
      [fullscreen]="true"
      title="Caricamento Survey"
    ></app-card-overlay>
  </ng-container>
</div>

